import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { resources } from '../../../resources/resources';

export function SectionHelp() {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);

  const helpPhoneLink = customerInfo.isSavingsUser
    ? resources.company.savingsPhoneLink
    : resources.company.phoneLink;
  const helpPhone = customerInfo.isSavingsUser
    ? resources.company.savingsPhone
    : resources.company.phone;
  const helpMailLink = customerInfo.isSavingsUser
    ? resources.company.savingsMailLink
    : resources.company.mailLink;
  const helpMail = customerInfo.isSavingsUser
    ? resources.company.savingsMail
    : resources.company.mail;

  return (
    <div className="section-help">
      {translate(resources.cart.help.message1)}{' '}
      <Link to="/help" target="_blank" className="section-help-strong">
        {' '}
        {translate(resources.cart.help.linkLabel)}
      </Link>{' '}
      {translate(resources.cart.help.message2)}
      <br />
      <Link to={translate(helpPhoneLink)}>{translate(helpPhone)}</Link>{' '}
      {translate(resources.cart.help.message3)}{' '}
      <Link to={translate(helpMailLink)}>{translate(helpMail)}</Link>{' '}
    </div>
  );
}
